<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active" v-on:click="goTo('/stats')">Estadísticas</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Cliente</a>
  </div>

  <h1 class="ui header">
    <img v-if="image_url" class="ui small image" :src="image_url">
    <img v-if="!image_url" class="ui small image" src="../../assets/name.png">
    
    <div class="content">Estadísticas {{client.toUpperCase()}}: {{year}} </div>
  </h1>
  <div class="rightButton">
    <a class="section" v-on:click="getStatsApms(year-1)"><i class="big arrow alternate circle down icon"></i></a>
    <a class="section" v-on:click="getStatsApms(year+1)"><i class="big arrow alternate circle up icon"></i></a>
  </div>
  <div class="ui tabular menu">
    <a class="item " v-on:click="goTo('/stats/'+client)">
      Cliente
    </a>
    <a class="item active" v-on:click="goTo('/stats-apms/'+client)">
      APMS
    </a>
  </div>
  <div v-if="!data" class="ui active centered inline loader"></div>
  <div v-if="data" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
      <!--  <chartjs-line :labels="mylabels" :datasets="mydatasets"></chartjs-line>-->
        <vue-good-table :columns="zutabeak" :rows="ilarak" :lineNumbers="true" @on-row-click="apmStats" styleClass="vgt-table striped condensed bordered">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'apm'">
              <span style="font-weight: bold;color:black">{{props.row.apm}}</span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'statsApmClient',
  props: ['client'],
  data() {
    return {
      data: null,
      year: null,
      zutabeak: null,
      ilarak: null,
      image_url: null
    }
  },
  created() {
    let year = new Date().getFullYear()
    this.getStatsApms(year)
    this.getImages()
  },
  methods: {
    async getImages() {
      await hapiickApi().get('/v1/images/stats?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
        let url = this.images.find((e) => {
          return (e.key === this.client)
        })
        if (url !== undefined) {
          this.image_url = url.url
        } else {
          this.image_ur = null
        }
      })
      .catch(() => console.log('error getting images'))
    },
    getStatsApms(year) {
      this.data = null
      this.year = year
      hapiickApi().post('/v2/stats/apms/clients', {
        admin_id: JSON.parse(localStorage.admin).id,
        year: year,
        client:this.client
      })
      .then(request => this.updateStatistics(request))
      .catch(() => console.log('error getting stats'))
    },
    updateStatistics(req) {
      this.zutabeak = [];
      this.ilarak = [];
      this.last_month = 12;
      this.data = JSON.parse(JSON.stringify(req.data.data));

      let hoy = new Date();
      let current_year = hoy.getFullYear();
      let datuak = this.data.monthPicks.slice();

      if (this.year == current_year) {
        this.last_month = hoy.getMonth() + 1;
      }
      
      this.zutabeak.push({
        label: 'APM',
        field: 'apm',
        filterOptions: {
          placeholder: 'APM',
          enabled: true, // enable filter for this column
        },
      })
     
      for (let i = 0; i < this.last_month; i++) {
        this.zutabeak.push({
          'label': this.$months[i],
          'field': this.$months[i],
          'type': 'number',
        })
      }

      this.zutabeak.push({
        'label': 'Total',
        'field': 'Total',
        'type': 'number',
      })

      this.ilarak = datuak;
    },
    apmStats(params) {
      //this.goTo('/apms/stats/' + params.row.key)
      this.goTo('/apms/stats/' + params.row.apt_id)
    },
    goTo(where) {
      this.$router.push(where)
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Stats/statsApmClient.vue